export default (item) => {
  if (!window.theme.settings.bookDetailsSettings) return
  const langugeLocale = window.theme.settings.shopLocale || 'en'
  const geoLocale = window.theme.settings.geolocationCountryCode || 'en'
  let customRetailers = ''
  // check for custom retailers by default
  if (item.custom) customRetailers = getCustomRetailers(item.custom, geoLocale)
  if (window.theme.settings.bookDetailsSettings.hardcodedRetailers) {
    customRetailers = window.theme.settings.bookDetailsSettings.hardcodedRetailers
  }
  // set custom retailers to default retailers if empty
  if (!customRetailers && item.retailers) customRetailers = item.retailers
  if (!customRetailers.length) return ''

  let selectLabel = 'Select Retailer'
  if (item.languages.select_retailer_label) selectLabel = item.languages.select_retailer_label
  let list = '<ul class="dropdown__inner">'
  list += `<li tabindex="0"><span>${selectLabel}</span></li><li><ul>`
  customRetailers.forEach((retailer) => {
    if (!retailer.path && !retailer.label) return
    list += `<li><a href="${retailer.path}" title="${retailer.label}" target="_blank" class="btn btn--full add-to-cart">${retailer.label}</a></li>`
  })
  list += '</li></ul>'
  const retailerType = window.theme.settings.bookDetailsSettings.retailer_links_view
  let retailerHeadline = langugeLocale !== 'en' ? item.languages.retailer_headline : window.theme.settings.bookDetailsSettings.retailer_links_headline
  retailerHeadline = retailerHeadline !== '' ? `<span>${retailerHeadline}</span>` : ''
  return `<div class="product-form__retailers__inner ${retailerType}">${retailerHeadline}<div class="dropdown">${list}</div></div>`
}

function getCustomRetailers (custom, locale) {
  if (!custom.retailers || !locale) {
    return ''
  }
  const formattedLocale = locale.toLowerCase()
  const customRetailers = custom.retailers
  if (!customRetailers[`${formattedLocale}_language`]) {
    return ''
  }

  return Object.values(customRetailers[`${formattedLocale}_language`])
}
